import { ILoadingStore } from 'src/models/loading-store/LoadingStore';
import { Base64 } from 'js-base64';

/** 비밀번호 유효성 검사 */
export const validPwd = (type: string, value: string) => {
  const regEng = /[A-Z|a-z]/;
  const regNum = /[0-9]/;
  const regLen = /^.{8,}$/;
  const regSpclChar = /[*~`!^\-_+@\#$%&\\\=\(\'\"]/;

  switch (type) {
    case 'eng':
      return regEng.test(value);

    case 'num':
      return regNum.test(value);

    case 'len':
      return regLen.test(value);

    case 'spclChar':
      return regSpclChar.test(value);

    case 'all':
      return regEng.test(value) && regNum.test(value) && regLen.test(value) && regSpclChar.test(value);

    default:
      break;
  }
}

export const CallApiToStore = async (
  storeFunction: Promise<any>,
  type: 'page' | 'api',
  loadingStore: ILoadingStore,
) => {
  loadingStore.allLoading();
  await storeFunction
    .then(() => {
      loadingStore.closeLoadingNoMsg();
    })
    .catch((e) => {
      loadingStore.closeLoadingNoMsg();
    })
    .finally(() => {
      loadingStore.closeLoadingNoMsg();
    });
};

/** Base64 암호화 */
export const encryptBase64 = (value: string) => {
  const baseEncode = Base64.encode(value);
  return baseEncode;
};

/** Base64 복호화 */
export const decryptBase64 = (value: string) => {
  const baseDecode = Base64.decode(value);
  return baseDecode;
};

export const convertAuthType =(value : string) => {
  switch(value) {
    case 'SuperAdmin':
      return 5100001;
    
    case 'Admin':
      return 5100002;

    case 'User':
      return 5100003;
  }

}